/**
 * Cognito configuration — values injected at build time by webpack DefinePlugin.
 */
export const AUTH_CONFIG = {
  userPoolId: COGNITO_USER_POOL_ID,
  clientId: COGNITO_CLIENT_ID,
  domain: COGNITO_DOMAIN,
  redirectUri: typeof window !== 'undefined' ? `${window.location.origin}/callback` : '',
  logoutUri: typeof window !== 'undefined' ? `${window.location.origin}/` : '',
  scopes: 'openid+profile+email',
};
